import { useState } from 'react';

export default function FAQ() {
  const [openIndex, setOpenIndex] = useState<number | null>(null);

  const faqs = [
    {
      question: 'What types of commercial facilities do you service?',
      answer: 'We service a wide range of commercial facilities including office buildings, restaurants, industrial and R&D facilities, retail spaces, warehouses, and more. Our team is trained to handle the unique cleaning requirements of each facility type.'
    },
    {
      question: 'How do you determine pricing for cleaning services?',
      answer: 'Pricing is based on several factors including facility size, cleaning frequency, specific services required, and any special requirements. We offer free on-site consultations to provide accurate quotes tailored to your needs and budget.'
    },
    {
      question: 'Are your cleaning products eco-friendly and safe?',
      answer: 'Yes! We prioritize the use of environmentally friendly, non-toxic cleaning products that are safe for your employees and the environment. All our products meet or exceed industry safety standards while delivering exceptional cleaning results.'
    },
    {
      question: 'What are your service hours and availability?',
      answer: 'We offer flexible scheduling including after-hours, overnight, and weekend services to minimize disruption to your business operations. Our team is available 24/7 for emergency cleaning needs and can accommodate your preferred schedule.'
    },
    {
      question: 'Are you licensed, bonded, and insured?',
      answer: 'Absolutely. We are fully licensed, bonded, and insured with comprehensive liability coverage. All our staff members are trained in proper cleaning protocols and safety procedures.'
    },
    {
      question: 'Do you require long-term contracts?',
      answer: 'We offer both flexible month-to-month agreements and long-term contracts. Our goal is to provide service options that work best for your business needs. There are no hidden fees or cancellation penalties.'
    },
    {
      question: 'What happens if we\'re not satisfied with the cleaning?',
      answer: 'Customer satisfaction is our top priority. If you\'re not completely satisfied with our service, contact us within 24 hours and we\'ll return to address any concerns at no additional charge. We stand behind our work with a 100% satisfaction guarantee.'
    },
    {
      question: 'Do you provide emergency cleaning services?',
      answer: 'Yes, we offer 24/7 emergency cleaning services for urgent situations such as water damage or post-event cleaning. Our team can be on-site quickly to handle any emergency cleaning needs.'
    },
    {
      question: 'What cleaning equipment and technology do you use?',
      answer: 'We use state-of-the-art commercial cleaning equipment including HEPA-filter vacuums, microfiber cleaning systems, and advanced floor care machines. Our technology ensures efficient, thorough cleaning while maintaining the highest standards of hygiene.'
    },
    {
      question: 'How do you ensure quality and consistency?',
      answer: 'We implement rigorous quality control measures including regular inspections, detailed cleaning checklists, and ongoing staff training. Each client is assigned a dedicated account manager who ensures consistent service delivery and addresses any concerns promptly.'
    }
  ];

  const scrollToContact = () => {
    const element = document.getElementById('contact');
    if (element) {
      element.scrollIntoView({ behavior: 'smooth' });
    }
  };

  return (
    <section id="faq" className="py-24 bg-white">
      <div className="max-w-4xl mx-auto px-6">
        <div className="text-center mb-16">
          <h2 className="text-5xl font-light text-gray-400 mb-1">Frequently Asked</h2>
          <h3 className="text-6xl font-serif italic text-gray-900">Questions</h3>
        </div>

        <div className="space-y-0">
          {faqs.map((faq, index) => (
            <div key={index} className="border-b border-gray-200">
              <button
                onClick={() => setOpenIndex(openIndex === index ? null : index)}
                className="w-full py-6 flex items-center justify-between text-left cursor-pointer hover:bg-gray-50 transition-colors px-4"
              >
                <span className="text-lg font-bold text-gray-900 pr-8">{faq.question}</span>
                <i
                  className={`${
                    openIndex === index ? 'ri-subtract-line' : 'ri-add-line'
                  } text-2xl text-gray-900 flex-shrink-0 transition-transform`}
                ></i>
              </button>
              {openIndex === index && (
                <div className="px-4 pb-6 pl-8">
                  <p className="text-gray-600 text-base leading-relaxed">{faq.answer}</p>
                </div>
              )}
            </div>
          ))}
        </div>

        <div className="text-center mt-16">
          <p className="text-gray-600 text-base mb-6">Still have questions?</p>
          <button
            onClick={scrollToContact}
            className="border-2 border-gray-900 text-gray-900 px-8 py-3 rounded-lg text-base font-semibold hover:bg-gray-900 hover:text-white transition-all inline-flex items-center gap-2 cursor-pointer whitespace-nowrap"
          >
            <i className="ri-phone-line text-xl"></i>
            Contact Our Team
          </button>
        </div>
      </div>
    </section>
  );
}